import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

// IANA timezone ids covering Canada, the United States and Mexico -- the
// only timezones relevant to our users.
const NORTH_AMERICA_TIMEZONES = [
    // Canada
    'America/St_Johns', 'America/Halifax', 'America/Glace_Bay', 'America/Moncton',
    'America/Goose_Bay', 'America/Toronto', 'America/Nipigon', 'America/Thunder_Bay',
    'America/Iqaluit', 'America/Pangnirtung', 'America/Resolute', 'America/Atikokan',
    'America/Rankin_Inlet', 'America/Winnipeg', 'America/Rainy_River', 'America/Regina',
    'America/Swift_Current', 'America/Edmonton', 'America/Cambridge_Bay', 'America/Yellowknife',
    'America/Inuvik', 'America/Creston', 'America/Dawson_Creek', 'America/Fort_Nelson',
    'America/Vancouver', 'America/Whitehorse', 'America/Dawson',
    // United States
    'America/New_York', 'America/Detroit', 'America/Kentucky/Louisville',
    'America/Kentucky/Monticello', 'America/Indiana/Indianapolis', 'America/Indiana/Vincennes',
    'America/Indiana/Winamac', 'America/Indiana/Marengo', 'America/Indiana/Petersburg',
    'America/Indiana/Vevay', 'America/Chicago', 'America/Indiana/Tell_City',
    'America/Indiana/Knox', 'America/Menominee', 'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem', 'America/North_Dakota/Beulah', 'America/Denver',
    'America/Boise', 'America/Phoenix', 'America/Los_Angeles', 'America/Anchorage',
    'America/Juneau', 'America/Sitka', 'America/Metlakatla', 'America/Yakutat',
    'America/Nome', 'America/Adak', 'Pacific/Honolulu', 'America/Puerto_Rico',
    // Mexico
    'America/Mexico_City', 'America/Cancun', 'America/Merida', 'America/Monterrey',
    'America/Matamoros', 'America/Mazatlan', 'America/Chihuahua', 'America/Ojinaga',
    'America/Hermosillo', 'America/Tijuana', 'America/Bahia_Banderas',
];

export default {
    namespaced: true,
    state() {
        return {
            list: NORTH_AMERICA_TIMEZONES,
            detectedTimezone: null,
        };
    },
    mutations,
    actions,
    getters,
};
